import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar-scroll"
export default class extends Controller {
  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    this.scrollThreshold = 50 // pixels from top before navbar becomes solid
    this.lastScrollPosition = 0
    this.hideThreshold = 100 // pixels to scroll before hiding navbar

    // Check initial scroll position
    this.handleScroll()

    // Listen for scroll events with throttling
    window.addEventListener('scroll', this.throttledScroll.bind(this), { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  throttledScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.handleScroll()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  handleScroll() {
    const navbarContainer = document.querySelector('.navbar-container')
    if (!navbarContainer) return

    const scrollPosition = window.scrollY
    const scrollingDown = scrollPosition > this.lastScrollPosition
    const scrollingUp = scrollPosition < this.lastScrollPosition

    // Handle solid/transparent state
    if (scrollPosition > this.scrollThreshold) {
      // Add solid background and shadow
      navbarContainer.classList.add('navbar-solid')
      navbarContainer.classList.remove('navbar-transparent-state')
    } else {
      // Return to transparent state
      navbarContainer.classList.remove('navbar-solid')
      navbarContainer.classList.add('navbar-transparent-state')
    }

    // Handle auto-hide behavior (only if scrolled past threshold)
    if (scrollPosition > this.hideThreshold) {
      if (scrollingDown) {
        // Hide navbar when scrolling down
        navbarContainer.classList.add('navbar-hidden')
      } else if (scrollingUp) {
        // Show navbar when scrolling up
        navbarContainer.classList.remove('navbar-hidden')
      }
    } else {
      // Always show navbar near the top
      navbarContainer.classList.remove('navbar-hidden')
    }

    this.lastScrollPosition = scrollPosition
  }
}
